import { useState } from 'react';
import type { SourceCitation } from '../../../shared/types';

/* Élément de la liste « Sources juridiques » + sa pastille de type.
 * Extrait tel quel de ResultsDisplay.tsx. */

function sourceBadgeClass(type: SourceCitation['type']): string {
  if (type === 'LOI') return 'bg-blue-200 text-ink';
  if (type === 'JURISPRUDENCE') return 'bg-sun-200 text-ink';
  return 'bg-cream-card text-ink';
}

export default function SourceItem({ source, forceExpanded, sourceRef }: { source: SourceCitation; forceExpanded?: boolean; sourceRef?: React.Ref<HTMLLIElement> }) {
  const [expanded, setExpanded] = useState(false);
  const hasContent = !!source.articleContent;
  const isOpen = expanded || forceExpanded;
  return (
    <li ref={sourceRef} className={`text-xs transition-colors duration-500 rounded-md px-1 -mx-1 ${forceExpanded ? 'bg-violet-50' : ''}`}>
      <div className={`flex items-start gap-2 ${hasContent ? 'cursor-pointer' : ''}`} onClick={() => hasContent && setExpanded(!expanded)}>
        <span className={`px-1.5 py-0.5 rounded font-medium shrink-0 ${sourceBadgeClass(source.type)}`}>{source.type}</span>
        <span className="text-slate-600 flex-1">
          {source.title} — {source.reference}
          {source.date && <span className="text-slate-400 ml-1">({source.date})</span>}
        </span>
        {hasContent && (
          <span className="text-slate-400 shrink-0 transition-transform duration-200" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
        )}
      </div>
      {isOpen && source.articleContent && (
        <div className="mt-2 ml-6 p-3 rounded-lg bg-slate-50 border border-slate-200 text-xs text-slate-600 leading-relaxed whitespace-pre-line">
          {source.articleContent}
        </div>
      )}
    </li>
  );
}
